/*
 * Bulkstate.js
 *
 * Initialisation of Bulk state page
 * Loads reporting page for bulk tanks
 *
 */

/*
 * Initialisation function for when voyage page is loaded
 */
function InitialiseBulkPlanning() {
  $('html').unbind('click');
  $('html').unbind('hidden.bs.popover');
  InitialiseBulkDialogs();

  VRC.BulkStateView.init(VRC.BulkTankManager.toJson());
  VRC.BulkLoadingAreaView.init();
  VRC.BulkOffloadAraeView.init();
  VRC.BulkDeviationView.init();
  VRC.BulkToolbarView.init();


}

/*
 * Actions for when page is left
 */
function OnLeavingBulkPage() {
    VRC.BulkState.saveToLocalStorage()
}

/*
 * Menu selection
 */
function BulkMenuSelect( p_select, p_params ) {
    if( p_select == 2 ) {
        VRC.BulkState.saveToLocalStorage();
        VRC.ErrorHandleService.showMessage('Data for bulk tanks saved locally', G_MSG_TYPE_NORMAL );
    }
    else if( p_select == 3) {
        VRC.BulkState.loadFromLocalStorage();
        VRC.ErrorHandleService.showMessage('Data for bulk tanks loaded from local', G_MSG_TYPE_NORMAL );
    }
    else if( p_select == 5) {
        var msg = 'This will clear your bulk tank data. Do you want to proceed?';
        var onConfirm = function(){

            VRC.BulkTankManager.clearTanks();
            VRC.BulkStateView.render();
            VRC.ErrorHandleService.showMessage( 'Cleared all bulk data entries.', G_MSG_TYPE_NORMAL );
        };
        VRC.ConfirmationModal.show({msg : msg, onConfirm : onConfirm})

    }
    else if( p_select == 6 ) {
        OpenSubmitDialog();
    }
    else if( p_select == 7 ) {
        ConfirmFetchData();
    }
};

function BulkSubMenuChoice(p_select) {
    if(p_select == 2) {
        g_remote_object.FetchHTMLFromServer( g_bulk_planning, ParseWELSForm, 'info', 'fuel_documents');
    }
};



var VRC = VRC || {};

VRC.BulkState = (function(){

    var init = function(){
        VRC.BulkCompatibility.init();
        loadFromLocalStorage();
    };

    var mapOldFormatToNewFormat = function(bulkTank){
        return  {
            bulkTankId : bulkTank.id,
            tankName : bulkTank.name,
            tankType : bulkTank.type,
            tankShape : bulkTank.shape,
            tankCapacity : bulkTank.capacity,
            tankRadius: bulkTank.radius,
            positionX : bulkTank.x_pos,
            positionY: bulkTank.y_pos,
            consumableSeqNo : bulkTank.consumable_seq_no,
            valueUnit : bulkTank.value_unit,
            availableForDelivery : bulkTank.available_for_delivery,
            bulkTankPumpSystemName : bulkTank.bulk_tank_pump_system_name,
            pumpSystemColorCode : bulkTank.color_code
        };
    };

    var saveToLocalStorage = function(json){
        json = json || {};
        if(!json.bulkTanks){
            json.bulkTanks = VRC.BulkTankManager.toJson();
        }
        if(!json.deviations){

            json.deviations = VRC.SpecialBulkTanks.toJson();
        }

        g_localsave_object.SetLocalStorageItem( G_LS_NAMES.BULK_TANKS, json);
    };

    var loadFromLocalStorage = function(){

        var json =  g_localsave_object.GetLocalStorageItem( G_LS_NAMES['BULK_TANKS']) || {};

        VRC.BulkTankManager.createBulkTankObjects(json.bulkTanks);

        json.deviations = json.deviations || [];
        VRC.SpecialBulkTanks.init(json.deviations);
    };

    var isCurrentPage = function(){
        return g_current_page === G_PAGE.BULK_PAGE;
    };

    var loadBulkTanksOnline  =  function(){
        var deferred = $.Deferred();
        var fetchData = VRC.CommunicationService.fetchData({}, 'bulk_tanks');
        fetchData.done(function(owner, data){
            parseFromServer(data);
            loadFromLocalStorage();
            deferred.resolve();
        });

        return deferred.promise();
    };

    var importData = function (data) {
        VRC.BulkTankManager.importBulkData(data);
        saveToLocalStorage();
        if (isCurrentPage()) {
            VRC.BulkStateView.render();
            VRC.ErrorHandleService.showMessage('Data loaded from server', G_MSG_TYPE_SUCCESS);
        }
    };

    var fetch = function(){
        VRC.BulkTankManager.clearTanks();
        var deferred = $.Deferred();
        var fetchData = VRC.CommunicationService.fetchData({}, 'bulk_data');
        fetchData.done(function(owner, data){
            importData(data);
            deferred.resolve();
        });
        fetchData.fail(function(){
            VRC.ErrorHandleService.showMessage('Something went wrong', G_MSG_TYPE_ERROR)
        });
        return deferred.promise();
    };

    var parseFromServer = function(serverInfo){
        var bulkTanks  = _.map(serverInfo.bulk_tanks, function(bulkTank){ return mapOldFormatToNewFormat(bulkTank)});
        saveToLocalStorage({bulkTanks : bulkTanks, deviations : []});
    };

    return{
        mapOldFormatToNewFormat : mapOldFormatToNewFormat,
        fetch : fetch,
        fetchBulkTanks : loadBulkTanksOnline,
        saveToLocalStorage : saveToLocalStorage,
        loadFromLocalStorage : loadFromLocalStorage,
        init : init,
        importData : importData
    }
})();




